import React from 'react';
import axios from 'axios';
import styles from '../styles/DynamicModal.module.css';

const AddNewLabelCategoryPhaseModal = ({ closeModal, type, id }) => {
    const [status, setStatus] = React.useState('');
    const [labelName, setLabelName] = React.useState('');

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    const addNewLabel = (e) => {
        e.preventDefault();

        axios.post('/api/add-new-label', {labelName})
        .then(() => {
            setStatus('Новый тип дел успешно добавлен.');
            window.location.reload();
        })
        .catch((error) => {
            setStatus(`Ошибка добавления нового типа дел: ${error.response?.data.message || error.message}`);
        });
    }

    const [categoryName, setCategoryName] = React.useState('');

    const addNewCategory = (e) => {
        e.preventDefault();

        axios.post('/api/add-new-category', {categoryName, id})
        .then(() => {
            setStatus('Новая категория успешно добавлена.');
            window.location.reload();
        })
        .catch((error) => {
            setStatus(`Ошибка добавления новой категории: ${error.response?.data.message || error.message}`);
        });
    }

    const [phaseName, setPhaseName] = React.useState('');
    const [phaseTime, setPhaseTime] = React.useState('');
    const [phaseTypeSch, setPhaseTypeSch] = React.useState('0');

    const addNewPhase = (e) => {
        e.preventDefault();

        axios.post('/api/add-new-phase', {phaseName, phaseTime, phaseTypeSch, id})
        .then(() => {
            setStatus('Новый этап успешно добавлен.');
            window.location.reload();
        })
        .catch((error) => {
            setStatus(`Ошибка добавления нового типа дел: ${error.response?.data.message || error.message}`);
        });
    }


    if (type=='label') {
        return (
            <div className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onSubmit={(e) => addNewLabel(e)} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.header}>
                        <h1>Добавьте новый тип в систему</h1>
                        <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                        </svg>
                    </div>
                    <div className={styles.main}>
                    <a>Введите название (например, Наблюдение):</a>
                    <input type='text' placeholder='Введите название нового типа' minLength='3' maxLength='200' value={labelName} onChange={(e) => setLabelName(e.target.value)} required />
                    {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                    <button className='button maxWidth black'>Добавить</button>
                    </div>
                </form>
            </div>
        )
    } else if (type == 'category') {
        return (
            <div className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onSubmit={(e) => addNewCategory(e)} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.header}>
                        <h1>Добавьте новую категорию в систему</h1>
                        <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                        </svg>
                    </div>
                    <div className={styles.main}>
                    <a>Введите название (например, О введении наблюдения):</a>
                    <input type='text' placeholder='Введите название новой категории' minLength='3' maxLength='200' value={categoryName} onChange={(e) => setCategoryName(e.target.value)} required />
                    {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                    <button className='button maxWidth black'>Добавить</button>
                    </div>
                </form>
            </div>
        )
    } else if (type == 'phase') {
        return (
            <div className={styles.liningOver} onClick={closeModal}>
                <form className={styles.lining} onSubmit={(e) => addNewPhase(e)} onClick={(e) => e.stopPropagation()}>
                    <div className={styles.header}>
                        <h1>Добавьте новый этап в систему</h1>
                        <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                        </svg>
                    </div>
                    <div className={styles.main}>
                        <a>Введите название (например, О введении наблюдения):</a>
                        <input type='text' placeholder='Введите название нового этапа' minLength='3' maxLength='500' value={phaseName} onChange={(e) => setPhaseName(e.target.value)} required />
                        <a>Введите срок исполнения этапа в днях:</a>
                        <input type='text' placeholder='Введите срок в днях' minLength='1' maxLength='3' value={phaseTime} onChange={(e) => setPhaseTime(e.target.value)} required />
                        <div className={styles.lineCheckBox}>
                            <a>Отметьте, если срок отсчитывается только по рабочим дням</a>
                            <input
                                type='checkbox'
                                checked={phaseTypeSch === '1'}
                                onChange={(e) => setPhaseTypeSch(e.target.checked ? '1' : '0')}
                            />
                        </div>
                        {status && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{status}</a>}
                        <button className='button maxWidth black'>Добавить</button>
                    </div>
                </form>
            </div>
        )
    }

    return (
        <div className={styles.liningOver} onClick={closeModal}>
            <form className={styles.lining} onSubmit={(e) => addNewLabel(e)} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Ошибка</h1>
                    <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                <a>Системе не удалось корректно обработать запрос</a>
                </div>
            </form>
        </div>
    )
};

export default AddNewLabelCategoryPhaseModal;
